'use client'

import { type MouseEvent } from 'react'
import NextLink, { type LinkProps as NextLinkProps } from 'next/link'
import { useHeaderContext } from '@/context/HeaderContext'
import { NAV_PREFETCH } from '@/lib/prefetch'

type LinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & NextLinkProps

export default function NavLink({ children, href, className, onClick, ...props }: LinkProps) {
  const { setShowMenu, setFocus } = useHeaderContext()

  const resetNavigation = () => {
    setShowMenu(false)
    setFocus(null)
  }

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    resetNavigation()
    onClick?.(event)
  }

  if (!href) return null

  return (
    <NextLink
      href={href}
      className={className}
      onClick={handleClick}
      {...props}
      prefetch={NAV_PREFETCH}
    >
      {children}
    </NextLink>
  )
}
